export default __webpack_public_path__ + "static/media/workshop3.a73a2a2e.jpg";